import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useLocationMissing from "./useLocationMissing";

const LocationRequiredModal = () => {
  const { locationMissing, isLoading } = useLocationMissing();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.user);

  // If still loading or location is fine, don't show anything
  if (isLoading || !locationMissing) return null;

  // Determine the correct profile page path
  const profilePath = userInfo?.is_chef ? "/shef/profile" : "/profile";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white max-w-md w-full mx-4 p-6 rounded-2xl shadow-2xl text-center">
        <div className="mb-4 text-primary">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-16 h-16 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-bold mb-2">Location Required</h2>
        <p className="text-gray-600 mb-6">
          Please set your delivery / pickup location in your profile before you can use the app.
          Drag the pin or search for a landmark on the map.
        </p>
        <button
          onClick={() => navigate(profilePath)}
          className="w-full bg-primary hover:bg-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Set My Location
        </button>
        <p className="mt-4 text-xs text-gray-400">
          You won’t be able to browse until your location is saved.
        </p>
      </div>
    </div>
  );
};

export default LocationRequiredModal;